var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 131,
    viewBox: "0 0 116 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.09 110.058V20.377H52.317C51.4827 20.377 50.8081 19.6853 50.8081 18.8516V4.60833C50.8081 0.13847 45.0562 -1.70623 42.4466 1.92997L2.18371 58.2467V58.229C-0.727715 62.2909 -0.727715 67.7363 2.18371 71.7982L42.4466 128.115C45.0562 131.751 50.8081 129.906 50.8081 125.437V111.566C50.8081 110.732 51.4827 110.058 52.317 110.058H115.09Z",
    fill: "url(#paint0_linear_126_312)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.345 82.9092C49.689 82.9092 47.289 82.2372 45.145 80.8932C43.033 79.5492 41.369 77.5972 40.153 75.0372C38.937 72.4452 38.329 69.3092 38.329 65.6292C38.329 61.9492 38.937 58.8292 40.153 56.2692C41.369 53.6772 43.033 51.7092 45.145 50.3652C47.289 49.0212 49.689 48.3492 52.345 48.3492C55.033 48.3492 57.433 49.0212 59.545 50.3652C61.657 51.7092 63.321 53.6772 64.537 56.2692C65.785 58.8292 66.409 61.9492 66.409 65.6292C66.409 69.3092 65.785 72.4452 64.537 75.0372C63.321 77.5972 61.657 79.5492 59.545 80.8932C57.433 82.2372 55.033 82.9092 52.345 82.9092ZM52.345 77.4852C53.913 77.4852 55.273 77.0692 56.425 76.2372C57.577 75.3732 58.473 74.0612 59.113 72.3012C59.785 70.5412 60.121 68.3172 60.121 65.6292C60.121 62.9092 59.785 60.6852 59.113 58.9572C58.473 57.1972 57.577 55.9012 56.425 55.0692C55.273 54.2052 53.913 53.7732 52.345 53.7732C50.841 53.7732 49.497 54.2052 48.313 55.0692C47.161 55.9012 46.249 57.1972 45.577 58.9572C44.937 60.6852 44.617 62.9092 44.617 65.6292C44.617 68.3172 44.937 70.5412 45.577 72.3012C46.249 74.0612 47.161 75.3732 48.313 76.2372C49.497 77.0692 50.841 77.4852 52.345 77.4852ZM70.1459 74.7972V70.4772L86.7059 48.8292H93.3779L77.0579 70.4772L73.9379 69.5172H100.578V74.7972H70.1459ZM88.5779 82.4292V74.7972L88.7699 69.5172V62.7492H94.6259V82.4292H88.5779Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_312",
    x1: 93.6361,
    y1: 0,
    x2: 93.6361,
    y2: 130.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A5298"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow4);
export default __webpack_public_path__ + "static/media/arrow4.5cc7caa46135acabcd9cbe401b1dcff1.svg";
export { ForwardRef as ReactComponent };